function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { safeSelect } from '@sie/web-common-utils';
import Media from '../Media';
import Image from '../Image';
import classNames from '../utils/classNames';
/**
 * **DEPRECATED** Will be removed in v1. Use GameBackgroundImage instead
 *
 * The BackgroundImage component is typically used at the top of a page to draw
 * attention to the content. It can be seen in use within the PDC / PXG08 PDPs.
 *
 * ## Reference Design
 * - [Detailed Design](https://atlas.np.tools.playstation.net/design/6cc006b8-adee-407e-be67-8ac12823e414/8?bounds=-0.767,0.006,2.535,1.286)
 * - [Redline Design](https://atlas.np.tools.playstation.net/design/1f0fb24c-5b92-4705-9c89-9dd1405b4ab4/2?bounds=-0.944,0.004,2.888,1.465)
 *
 * ## Composed of
 * - [Media](../Media/README.md)
 *
 * ## Related Components
 * - [Image](../Image/README.md)
 * - [Media](../Media/README.md)
 *
 * ## Usage
 *
 * With hero image
 *
 * ```jsx
 * <BackgroundImage
 *   heroImage={(
 *    <Media
 *      src="http://images.com/cool-image.webp"
 *      alt="description of image"
 *    />
 *  )}
 * />
 * ```
 *
 * With tile image
 *
 * ```jsx
 * <BackgroundImage
 *   tileImage={(
 *    <Media
 *      src="http://images.com/cool-image.webp"
 *      alt="description of image"
 *    />
 *  )}
 * />
 * ```
 *
 * With tile image and overlay
 *
 * ```jsx
 * <BackgroundImage
 *   withOverlay
 *   tileImage={(
 *    <Media
 *      src="http://images.com/cool-image.webp"
 *      alt="description of image"
 *    />
 *  )}
 * />
 * ```
 */

var BackgroundImage = /*#__PURE__*/function (_PureComponent) {
  _inherits(BackgroundImage, _PureComponent);

  var _super = _createSuper(BackgroundImage);

  function BackgroundImage() {
    _classCallCheck(this, BackgroundImage);

    return _super.apply(this, arguments);
  }

  _createClass(BackgroundImage, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          qa = _this$props.qa,
          className = _this$props.className,
          children = _this$props.children,
          heroImage = _this$props.heroImage,
          tileImage = _this$props.tileImage,
          withOverlay = _this$props.withOverlay,
          noOverlay = _this$props.noOverlay;
      var fallbackSrc = 'default-game.png';
      var heroSrc = safeSelect(heroImage, 'props.src');
      var tileSrc = safeSelect(tileImage, 'props.src');
      var tileAlt = safeSelect(tileImage, 'props.alt');
      return /*#__PURE__*/React.createElement("div", {
        "data-qa": qa,
        className: classNames(className, 'psw-background-image', 'psw-l-anchor', 'psw-fill-x', {
          'psw-with-overlay': withOverlay
        })
      }, heroSrc && /*#__PURE__*/React.createElement("div", {
        className: "psw-layer"
      }, /*#__PURE__*/React.createElement(Media, {
        qa: "".concat(qa, "#heroImage"),
        className: "psw-fill",
        aspectRatio: "16:9",
        width: "100%",
        fit: "cover",
        place: "top-right",
        src: heroSrc,
        alt: safeSelect(heroImage, 'props.alt')
      })), !heroSrc && /*#__PURE__*/React.createElement("div", {
        className: classNames('psw-grid-container', 'psw-grid-x', 'psw-layer')
      }, /*#__PURE__*/React.createElement("div", {
        className: classNames('psw-cell', 'psw-mobile-p-12', 'psw-tablet-p-offset-2', 'psw-tablet-p-8', 'psw-tablet-l-offset-6', 'psw-tablet-l-5', 'psw-m-t-0', 'psw-m-t-2xl@tablet-p', 'psw-m-t-3xl@desktop', 'psw-full-bleed@mobile-l-and-below')
      }, /*#__PURE__*/React.createElement(Media, {
        qa: "".concat(qa, "#tileImage"),
        aspectRatio: "1:1",
        width: "100%",
        fit: "cover",
        place: "center",
        src: tileSrc || fallbackSrc,
        alt: tileAlt,
        useStatic: !tileSrc
      }, /*#__PURE__*/React.createElement(Image, {
        aspectRatio: "1:1",
        width: "100%",
        fit: "cover",
        place: "center",
        src: fallbackSrc,
        alt: tileAlt,
        useStatic: true
      })))), !noOverlay && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: classNames('psw-background-image-overlay', 'psw-layer')
      })), children && /*#__PURE__*/React.createElement("div", {
        className: "psw-layer"
      }, children));
    }
  }]);

  return BackgroundImage;
}(PureComponent);

BackgroundImage.defaultProps = {
  qa: '',
  children: null,
  heroImage: null,
  tileImage: null,
  className: '',
  withOverlay: false,
  noOverlay: false
};
BackgroundImage.propTypes = {
  qa: PropTypes.string,

  /**
   * Content to layer on top of the background image
   */
  children: PropTypes.node,

  /**
   * The image component containing the src and alt props used to display the hero image
   */
  heroImage: PropTypes.node,

  /**
   * The image component containing the src and alt props used to display the tile image
   */
  tileImage: PropTypes.node,

  /**
   * Whether to show the overlay / scrim at larger screen sizes
   */
  withOverlay: PropTypes.bool,

  /**
   * Remove overlay at all breakpoints
   */
  noOverlay: PropTypes.bool,

  /**
   * Additional classes to add to the root of the component
   */
  className: PropTypes.string
};
export default BackgroundImage;